import React from 'react';

import FieldString from '../../../components/plain/FieldString';
import FieldEnum from '../../../components/plain/FieldEnum';
import FieldList_CardsPanel from '../../../components/plain/FieldList_CardsPanel';

class TabAANames extends React.Component {
	
	constructor(props) {
		super(props);
	}

	nameCardBuilder = (fieldName, index) => {
		let plain = this.props.plain;
		let card = '';
		let language = fieldName.value.language.value;
		if( language ) {
			let languageText = plain.realm.getEnumerationItemText( plain.enumLanguage, language);
			card += languageText + '; ';
		}
		if( fieldName.value.shortName.value )
			card += fieldName.value.shortName.value;
		else if( fieldName.value.fullName.value )
			card += fieldName.value.fullName.value;
		return card;
	}
	buildNamePanel = (fieldGroup, listItemInfo) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<NamePanel fieldGroup={fieldGroup} listItemInfo={listItemInfo} 
				instance={instance} plain={plain} readOnly={readOnly}
			/>
		);
	}

	render() {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		let readOnly = this.props.readOnly;
		return (
			<div style={{padding: '10px' }}>
				<FieldList_CardsPanel path={'/name'} instance={instance} parentField={parentField} plain={plain} 
					buildItemComponent={this.buildNamePanel} itemCardBuilder={this.nameCardBuilder} 
					labelEmptyToHeader={true} ignoreTitle={true} readOnly={readOnly}
					styles={{
						divMain: {
							padding: '10px 10px 10px 10px',
							backgroundColor: 'rgb(200,200,200)',
							border: '1px solid blue',
							marginTop: '10px',
							marginBottom: '10px'
						},
						divCardsBlock: {
							backgroundColor: 'rgb(200,200,200)',
							minWidth: '300px'
						},
						divCard: {
							marginTop: '3px',
							padding: '7px',
							cursor: 'pointer',
							backgroundColor: 'rgb(230,230,230)',
							minHeight: '18px'
						}
					}}
				/>
			</div>
		);
	}
}

class NamePanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}

	render() {
		let fieldGroup = this.props.fieldGroup;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<div style={{flexGrow: '1', margin: '5px 0 0 0', padding: '10px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldEnum instance={instance} path={'language'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', marginRight: '20px'}}}
						/>
						<FieldEnum instance={instance} path={'nameType'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1'}}}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'keyName'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', marginRight: '20px'}}}
						 />
						<FieldString instance={instance} path={'name'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ input: {width: '150px', flexGrow: '1', marginRight: '20px'}}}
						 />
						<FieldString instance={instance} path={'secondName'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ input: {width: '150px', flexGrow: '1'}}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'shortName'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', marginRight: '20px'}}}
						 />
						<FieldString instance={instance} path={'fullName'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1'}}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'place'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', marginRight: '20px'}}}
						 />
						<FieldString instance={instance} path={'affilation'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1'}}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'comment'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1'}}}
						 />
					</div>
				</div>
			</div>
		)
	}
}

export default TabAANames;
